import web from './img/service.jpg';

const Sdata = [
    {
        id:1,
        imgsrc:web,
        title:"Web development",
    },
    {
        id:2,
        imgsrc:web,
        title:"App development",
    },
    {
        id:3,
        imgsrc:web,
        title:"Software development",
    },
    {
        id:4,
        imgsrc:web,
        title:"Digital Marketing",
    },
    {
        id:5,
        imgsrc:web,
        title:"Android development",
    },
]
export default Sdata;